<!-- vertical-layout -->
<vertical-layout></vertical-layout>
<!-- / vertical-layout -->

<app-popup-holidays *ngIf="_utilService.absencePopupOpen.holidays" (callbackFn)="updateMyAbsences()"></app-popup-holidays>
<app-staff-add-absence *ngIf="_utilService.absencePopupOpen.addAbsence"></app-staff-add-absence>
<app-popup-permissions *ngIf="_utilService.absencePopupOpen.permissions" (callbackFn)="updateMyAbsences()"></app-popup-permissions>
<app-popup-sickness *ngIf="_utilService.absencePopupOpen.sickness" (callbackFn)="updateMyAbsences()"></app-popup-sickness>
<app-open-ticket *ngIf="_utilService.moduleIsActive('ticket') && _utilService.popupOpenTicketIsOpen" (callbackFn)="updateTicketList()"></app-open-ticket>
<app-modal-add-task *ngIf="_utilService.moduleIsActive('task') && _utilService.popupOpenTaskIsOpen" (callbackFn)="closeModal()"></app-modal-add-task>
<!-- modale video tutorial -->
<app-tutorial-video *ngIf="_tutorialService.video_to_play"></app-tutorial-video>
<app-loader></app-loader>
<app-pdf-viewer></app-pdf-viewer>